enum ErrorType {
  EMAIL_ALREADY_EXISTS = "Email already exists",
}

const ERRORS_WITH_CUSTOM_HANDLING: string[] = [ErrorType.EMAIL_ALREADY_EXISTS];

export {ErrorType, ERRORS_WITH_CUSTOM_HANDLING};
